export const roundPercentValue = (numerator, denominator) => {
  if (denominator === 0) {
    return '0.0'
  }

  return (Math.round((numerator / denominator) * 1000) / 10).toFixed(1).toString()
}